import { render } from "./Date.vue?vue&type=template&id=58f987aa&lang=pug"
import script from "./Date.vue?vue&type=script&lang=ts"
export * from "./Date.vue?vue&type=script&lang=ts"
script.render = render

export default script